<template>
  <div @click="$emit('click')" style="cursor: pointer; display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 512 512"
    >
      <g
        :stroke="isDarkTheme ? headingTextColor : '#ffffff'"
        fill="none"
        stroke-width="25"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <!-- Left podium (3rd place) -->
        <rect x="25" y="320" width="130" height="155" rx="25" ry="25" />

        <!-- Center podium (1st place - tallest) -->
        <rect x="180" y="145" width="150" height="330" rx="25" ry="25" />

        <!-- Right podium (2nd place) -->
        <rect x="355" y="255" width="130" height="220" rx="25" ry="25" />
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: "PodiumIcon",
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    }
  }
};
</script>
<style scoped>
/* div:hover {
  opacity: 0.7;
  transition: opacity 0.2s;
} */
</style>
